module.exports = __webpack_public_path__ + "static/media/pret-card.ab8ef6d5.png";